import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthFormShell from '../../components/AuthFormShell.jsx'
import PasswordField from '../../components/PasswordField.jsx'
import Logo from '../../components/Logo.jsx'
import { useAuth } from '../../context/AuthContext.jsx'
import './authTitam.css'

export default function Login() {
  const location = useLocation()
  const navigate = useNavigate()
  const { listOrganizations, signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (location.state?.resetDone) {
      setSuccess('Senha alterada com sucesso. Entre novamente com sua nova senha.')
      navigate(location.pathname, { replace: true, state: {} })
    }
  }, [location.pathname, location.state, navigate])

  useEffect(() => {
    if (location.state?.signupDone) {
      setSuccess(
        'Conta criada com sucesso. Se o projeto exigir confirmacao de e-mail, conclua essa etapa e depois faca login para continuar.'
      )
      navigate(location.pathname, { replace: true, state: {} })
    }
  }, [location.pathname, location.state, navigate])

  async function handleSubmit(event) {
    event.preventDefault()
    setError('')
    setSuccess('')
    setLoading(true)

    const { data: signInData, error: authError } = await signIn(email, password)

    if (authError) {
      console.error('[auth] signIn falhou:', {
        name: authError.name,
        status: authError.status,
        code: authError.code,
        message: authError.message,
      })
      setError(authError.message || 'Credenciais invalidas')
      setLoading(false)
      return
    }

    if (!signInData?.session) {
      console.warn('[auth] signIn sem sessao (provavelmente confirmacao de e-mail pendente).')
      setError('E-mail ainda nao confirmado. Verifique sua caixa de entrada.')
      setLoading(false)
      return
    }

    const { data: organizations, error: organizationsError } = await listOrganizations()

    if (organizationsError) {
      console.error('[auth] listOrganizations falhou:', organizationsError)
      setError(
        organizationsError.message || 'Nao foi possivel verificar a organization do usuario.'
      )
      setLoading(false)
      return
    }

    setLoading(false)
    navigate((organizations ?? []).length > 0 ? '/google-ads' : '/onboarding')
  }

  return (
    <AuthFormShell
      showcaseVariant="titam"
      showcaseTitle="Seu negócio conectado. Sua equipe no controle."
      showcaseDescription="Conecte seus dados, organize sua gestão no TITAM. Mais clareza para acompanhar cada etapa e transformar relações em resultados."
    >
      <form className="auth-form-wrap auth-titam-form" onSubmit={handleSubmit}>
        <span className="auth-form-logo">
          <Logo height={14} />
        </span>
        <h1 className="auth-title">Bem-vindo de volta</h1>
        <p className="auth-desc">Entre na sua conta para acessar o painel.</p>

        {success ? <div className="auth-success">{success}</div> : null}
        {error ? <div className="auth-error">{error}</div> : null}

        <div className="field">
          <label className="field-label" htmlFor="login-email">
            E-mail
          </label>
          <input
            id="login-email"
            className="input"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            autoComplete="email"
          />
        </div>

        <div className="field">
          <PasswordField
            id="login-password"
            label="Senha"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
          <div className="auth-inline-action">
            <button type="button" onClick={() => navigate('/recuperar-senha')}>
              Esqueci minha senha
            </button>
          </div>
        </div>

        <button
          className="btn btn-full auth-titam-submit"
          type="submit"
          disabled={loading}
        >
          {loading ? 'Entrando...' : 'Entrar'}
        </button>

        <div className="auth-titam-signup">
          <div className="auth-titam-create">
            <span>Não tem conta?</span>
            <button type="button" onClick={() => navigate('/registro')}>
              Criar conta
            </button>
          </div>
          <button className="auth-titam-join" type="button" onClick={() => navigate('/registro?mode=join')}>
            Entrar em uma equipe
          </button>
        </div>
      </form>
    </AuthFormShell>
  )
}
